import { render } from "./ReplyDate.vue?vue&type=template&id=34cc4b0e&ts=true"
import script from "./ReplyDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReplyDate.vue?vue&type=script&setup=true&lang=ts"

import "./ReplyDate.vue?vue&type=style&index=0&id=34cc4b0e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyDate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34cc4b0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34cc4b0e', __exports__)) {
    api.reload('34cc4b0e', __exports__)
  }
  
  module.hot.accept("./ReplyDate.vue?vue&type=template&id=34cc4b0e&ts=true", () => {
    api.rerender('34cc4b0e', render)
  })

}


export default __exports__